import { getVendorAndEmailFromCookies } from './utilfunctions.js';
const paymentDialog = (() => {
  let isInitialized = false;

  const init = async () => {
    if (isInitialized) return;
    isInitialized = true;
  };

  const startPayment = async (event, spinner = null) => {
    event.preventDefault();


    const { email, vendor, folderId } = getVendorAndEmailFromCookies();

    const el = event.currentTarget;
    const planName = el.getAttribute('data-plan-name');
    const interval = el.getAttribute('data-active-interval') || 'monthly';
    const planDescription = el.getAttribute('data-plan-description') || '';
    const siteNameForStripe = getSiteNameForStripe();
    const compressed = sessionStorage.getItem('pricingDataCompressed');

    try {
      if (!isInitialized) {
        await init();
      }

      const url = getApiUrl('create-subscription-checkout', 'geoapi');
      const checkoutBase = getCheckoutBase();
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          planName,
          planDescription,
          email,
          vendor,
          siteNameForStripe,
          interval,
          checkoutBase,
          folderId,
          compressed,
        }),
      });

      if (!res.ok) throw new Error(`Fetch failed with status ${res.status}`);
      const data = await res.json();


     if (spinner) hideSpinner(spinner,300);
      if (data.manageSubscriptionUrl) {
        window.top.location.href = data.manageSubscriptionUrl;
      }
      else if (data.checkoutUrl) {
        window.top.location.href = data.checkoutUrl;
      } else {
        throw new Error('checkoutUrl not returned.');
      }
    } catch (err) {
      console.error('Checkout session creation failed:', err);
       if (spinner) hideSpinner(spinner,300);
      Swal.fire({
        title: getI18n('oops_something_wrong'),
        text: getI18n('somethingwrong'),
        icon: "error",
      });
    } finally {
       if (spinner) hideSpinner(spinner,300);
    }
  };

  const hideSpinner = async (spinner, timeout) => {
    setGuaranteedTimeoutIndexHtml(() => {
        spinner?.style && (spinner.style.display = 'none');
    }, timeout);
  }

  return {
    init,
    startPayment,
  };
})();

export default paymentDialog;
